module.exports = __webpack_public_path__ + "static/media/rating_4.2e4f1a00.svg";